export default "__VITE_ASSET__C_CamcHG__"